module.exports = __webpack_public_path__ + "static/media/29EUNOG10.7b585529.jpg";